const tokens = [
  "Open Source",
  "Sovereign AI",
  "Applied Research",
  "Knowledge Generation",
  "Agents",
  "Orchestration",
  "Real Deployment",
  "Knowledge Understanding",
  "Knowledge Execution",
  "Build In Public",
];

export default function Marquee() {
  const items = [...tokens, ...tokens];
  return (
    <section
      data-testid="marquee-section"
      className="relative w-full py-12 md:py-16 border-y border-white/10 overflow-hidden"
    >
      <div className="marquee flex gap-12 whitespace-nowrap">
        {items.map((t, i) => (
          <span
            key={i}
            className="font-display uppercase tracking-tight text-[#fafafa]"
            style={{ fontSize: "clamp(2rem, 5.5vw, 5.5rem)", lineHeight: 1 }}
          >
            {t}
            <span className="text-[#d4ff00] mx-8">●</span>
          </span>
        ))}
      </div>
    </section>
  );
}
